import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-aihobs-ecs-forgot-password',
  templateUrl: './aihobs-ecs-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './aihobs-ecs-forgot-password.component.css',
  ],
})
export class AihobsEcsForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }
}
